// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"56":"e68e6f27c657e0983c04","71":"03ab9787dbdc3814a645","393":"ec18f7cdfc377eeec8ad","453":"0cee59524caa5f71fdf6","540":"6e9cc628f428749434c0","549":"12780f97efb3aaa920d0","914":"81b8fa1c5b027dd005d9","933":"3b55261777935a7fa41d","961":"6d55e812efa5f737f89d"}[chunkId] + ".js";
};